import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";
import { openCookieSettings } from "utilities";

import styles from "./LegalLinks.module.css";

/**
 * The site-wide footer link set, rendered as bare links so each footer can wrap them in its own
 * `nav`/`div` and style them with its own CSS module.
 *
 * Kept in one place deliberately: payment-gateway reviews look for these pages by their exact
 * wording ("Refund & Cancellation Policy", "Contact Us"), and the list previously lived duplicated
 * across four footers where it was free to drift. The labels under `common:legalLinks` are held to
 * that same wording — treat them as fixed copy rather than something to reword.
 */
export const LegalLinks = () => {
	const { t } = useTranslation("common");

	return (
		<>
			<Link to={Paths.helpSupport}>{t("legalLinks.helpSupport")}</Link>
			<Link to={Paths.contact}>{t("legalLinks.contact")}</Link>
			<Link to={Paths.privacyPolicy}>{t("legalLinks.privacyPolicy")}</Link>
			<Link to={Paths.termsOfService}>{t("legalLinks.termsOfService")}</Link>
			<Link to={Paths.refundPolicy}>{t("legalLinks.refundPolicy")}</Link>
			<Link to={Paths.cookiePolicy}>{t("legalLinks.cookiePolicy")}</Link>
			<Link to={Paths.rightsPolicy}>{t("legalLinks.rightsPolicy")}</Link>
			<button className={styles.linkButton} onClick={openCookieSettings} type="button">
				{t("legalLinks.cookieSettings")}
			</button>
		</>
	);
};

export default LegalLinks;
